module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Farmland-c62154764c36d71cba29f4d2ceb7ff8b.png";